module.exports = __webpack_public_path__ + "img/singletrack-study-hero-2.5d55d42a.png";